import React, { Fragment, useRef } from 'react';
import MeasurementSwitch from "./Header/MeasurementSwitch";
import MobileHeaderTopLinks from "./MobileHeaderTopLinks";
import QuickSearchButton from "./QuickSearchButton";
import QuickSearchMobile from "./QuickSearchMobile";
import { useSelector } from "react-redux";
import Measurement from "./Measurement";
import { translate } from "../Services/translation";

const NavigationItem = ({ links = [], contentLink = null, depth = 0 }) => {
    const menuRef = useRef(null);
    const logo = useSelector((state) => state.navigation.logo);
    const toggleMenu = () => {
        menuRef.current.classList.toggle('navbar__menu--show');

        if (depth === 0) {
            document.getElementById('menu-overlay').classList.toggle('hidden');
        }
    };
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass = contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';

    const hasChildrenClass = links.length > 0 ? 'has-children' : null;

    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;

    const isCurrentLink = window.location.pathname === contentLink?.url;

    return (
        <Fragment>
            {!contentLink ? (
                <a
                    className={"navbar__link--block navbar__icon--menu navbar__icon" + " navbar__link--depth-2" + depth}
                    onClick={toggleMenu}
                ></a>
            ) : (
                <Fragment>
                    <a
                        className={`navbar__link ${selectedClass} ${!isCurrentLink || 'navbar__link--active'} ${hasChildrenClass || ''
                            } ${additionClass || ''}` + " navbar__link--depth-" + depth}
                        href={contentLink.url || '#'}
                        dangerouslySetInnerHTML={{ __html: contentLink.name }}
                    ></a>
                    {links.length > 0 && (
                        <i
                            className="navbar__icon--caret-right navbar__icon navbar__icon--open"
                            onClick={toggleMenu}
                        ></i>
                    )}


                </Fragment>
            )}

            {links.length > 0 && (
                <ul className={("navbar__menu navbar__menu--depth-" + depth)} ref={menuRef}>
                    <div className={`navbar__menu-header navbar__menu-header--depth-${depth}`}>
                        {!contentLink ? (
                            <div className="w-full">
                                <div className="navbar__mobile-menu-container">
                                    <img className="navbar__mobile-menu-logo"
                                        src={logo}
                                        alt="" />
                                    <span
                                        className="navbar__icon navbar__icon--close"
                                        onClick={toggleMenu}
                                    ></span>

                                </div>
                            </div>
                        ) : (
                            <Fragment>
                                <i
                                    className="navbar__icon--caret-left navbar__icon"
                                    onClick={toggleMenu}
                                ></i>
                                <span
                                    className="navbar__title"
                                    onClick={toggleMenu}
                                    dangerouslySetInnerHTML={{
                                        __html: contentLink.name,
                                    }}
                                ></span>
                            </Fragment>
                        )}
                    </div>

                    {depth === 0 && <li className="lg:hidden">
                        <div className="quick-search__mobile-container">
                            <QuickSearchMobile />
                        </div>
                    </li>}

                    <Fragment>
                        {depth === 0 && <li className="lg:hidden">
                            <div className="measurement-switch__mobile-container">
                                <MeasurementSwitch />
                            </div>
                        </li>}

                        {links.length > 0 &&
                            links.map(
                                (link) =>
                                (
                                    <li key={`navbar-item-${link.name}-depth-${depth}`}
                                        className={"navbar__item navbar__item " + ("navbar__item--" + link.numberOfColumns + "-columns") + (link.hasRightBorder ? " navbar__item--has-right-border" : "") + ((link.callToAction || link.featuredProduct) ? " navbar__item--hidden-mobile" : "") + (depth === 0 ? " navbar__item--border" : "") + (" navbar__item--depth-" + depth)}
                                    >
                                        {hasNameOrChildren(link) &&
                                            <NavigationItem
                                                links={link.links}
                                                contentLink={link}
                                                depth={depth + 1}
                                            />}

                                        {link.callToAction && <div
                                            className={"navbar__cta-item" + (link.callToAction.image ? " navbar__cta-item--with-image" : "")}>
                                            {link.callToAction.image && <><img className="navbar__cta-item-image"
                                                src={link.callToAction.image}
                                                alt="" />
                                                <div className="navbar__cta-item-overlay"></div>
                                            </>
                                            }

                                            <div className="navbar__cta-item-content">
                                                <p className="navbar__cta-item-text ">{link.callToAction.text}</p>
                                                <a href={link.url}
                                                    className=" button button--primary navbar__cta-item-button">{link.callToAction.buttonText}</a>
                                            </div>
                                        </div>}

                                        {link.featuredProduct && <a className="navbar__featured-product" href={link.featuredProduct.url}>
                                            <p className="navbar__featured-product-title">{link.featuredProduct.title}</p>

                                            <img className="navbar__featured-product-image" loading="lazy" src={link.featuredProduct.imageUrl} alt="" />

                                            <p className="navbar__featured-product-caption">{link.featuredProduct.series}</p>
                                            <p className="navbar__featured-product-name">{link.featuredProduct.name}</p>
                                            <p className="navbar__featured-product-model-id">{link.featuredProduct.modelId}</p>
                                            <p className="navbar__featured-product-attributes">{translate('product.capacity')} <span className="navbar__featured-product-attributes--red">
                                                <Measurement measurementUnit={JSON.parse(link.featuredProduct.capacity)}></Measurement>
                                            </span>
                                            </p>
                                        </a>}
                                    </li>
                                )
                            )}

                        {depth === 0 && <li><MobileHeaderTopLinks /></li>}
                    </Fragment>

                    {depth === 0 && <li className="hidden lg:block">
                        <QuickSearchButton />
                    </li>}


                </ul>
            )}
        </Fragment>
    );
};

export default NavigationItem;